import { render, staticRenderFns } from "./BacHeaderWithMenue.vue?vue&type=template&id=663f55fa&scoped=true&"
import script from "./BacHeaderWithMenue.vue?vue&type=script&lang=ts&"
export * from "./BacHeaderWithMenue.vue?vue&type=script&lang=ts&"
import style0 from "./BacHeaderWithMenue.vue?vue&type=style&index=0&id=663f55fa&prod&lang=scss&scoped=true&"
import style1 from "./BacHeaderWithMenue.vue?vue&type=style&index=1&id=663f55fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663f55fa",
  null
  
)

export default component.exports